import React from "react";

const TextButton = ({
  text = "Select OPtion", // Default text
  onClick,
  className = "", //position styling
  width = "127px", // Default width
  height = "35px", // Default height
  disabled = false, // Default disabled state
}) => {
  return (
    <div className={` ${className}`}>
      <button
        disabled={disabled}
        onClick={onClick}
        className={`font-medium text-center font-inter bg-light-blue text-blue-shades text-[13px] leading-4 px-3 py-2 border-none rounded-[5px] whitespace-nowrap
         ${disabled ? "cursor-not-allowed" : "cursor-pointer"}`}
        style={{
          width: width,
          height: height,
        }}
      >
        {text}
      </button>
    </div>
  );
};

export default TextButton;
